const emptySite = require('./images/white.png'); // 选中
const singleSite = require('./images/Seat_Single/Seat_Selected.png'); // 选中
const singleEmptySite = require('./images/Seat_Single/Seat_Available.png'); // 可选
const fixSingleSite = require('./images/3.png');
const saledSite = require('./images/Seat_Single/Seat_Sold_Out.png'); // 已售座位

const muliUnseledLeft = require('./images/Seat_Couple/Seat_Available_Left.png'); // 单票价情侣座 可选
const muliUnseledRight = require('./images/Seat_Couple/Seat_Available_Right.png');
const muliSeledLeft = require('./images/Seat_Couple/Seat_Selected_Left.png'); // 单票价情侣座 已选
const muliSeledRight = require('./images/Seat_Couple/Seat_Selected_Right.png');
const muliSaledLeft = require('./images/Seat_Sold_Out_Left.png'); // 单票价情侣座 已售
const muliSaledRight = require('./images/Seat_Sold_Out_Right.png');
// const muliSaledLeft = require('./images/Seat_Single/Seat_Sold_Out.png') // 单票价情侣座 已售
// const muliSaledRight = require('./images/Seat_Single/Seat_Sold_Out.png')
// 多票价 单座

const singleEmptySite_1 = require('./images/Seat_Single/Seat_Price_1.png'); // 可选
const singleEmptySite_1_U = require('./images/Seat_Single/u/Seat_Price_1_u.png'); // 可选
const singleEmptySite_2 = require('./images/Seat_Single/Seat_Price_2.png'); // 可选
const singleEmptySite_2_U = require('./images/Seat_Single/u/Seat_Price_2_u.png'); // 可选
const singleEmptySite_3 = require('./images/Seat_Single/Seat_Price_3.png'); // 可选
const singleEmptySite_3_U = require('./images/Seat_Single/u/Seat_Price_3_u.png'); // 可选
const singleEmptySite_4 = require('./images/Seat_Single/Seat_Price_4.png'); // 可选
const singleEmptySite_4_U = require('./images/Seat_Single/u/Seat_Price_4_u.png'); // 可选
const singleEmptySite_5 = require('./images/Seat_Single/Seat_Price_5.png'); // 可选
const singleEmptySite_5_U = require('./images/Seat_Single/u/Seat_Price_5_u.png'); // 可选
const singleEmptySite_6 = require('./images/Seat_Single/Seat_Price_6.png'); // 可选
const singleEmptySite_6_U = require('./images/Seat_Single/u/Seat_Price_6_u.png'); // 可选
const singleEmptySite_7 = require('./images/Seat_Single/Seat_Price_7.png'); // 可选
const singleEmptySite_7_U = require('./images/Seat_Single/u/Seat_Price_7_u.png'); // 可选
const singleEmptySite_8 = require('./images/Seat_Single/Seat_Price_8.png'); // 可选
const singleEmptySite_8_U = require('./images/Seat_Single/u/Seat_Price_8_u.png'); // 可选

const muliEmptySite_1_L = require('./images/Seat_Couple/Seat_Available_Price 1_Left.png'); // 可选
const muliEmptySite_1_L_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 1_left.png'); // 可选
const muliEmptySite_1_R = require('./images/Seat_Couple/Seat_Available_Price 1__Right.png'); // 可选
const muliEmptySite_1_R_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 1_right.png'); // 可选
const muliEmptySite_2_L = require('./images/Seat_Couple/Seat_Available_Price 2_Left.png'); // 可选
const muliEmptySite_2_L_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 2_left.png'); // 可选
const muliEmptySite_2_R = require('./images/Seat_Couple/Seat_Available_Price 2__Right.png'); // 可选
const muliEmptySite_2_R_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 2_right.png'); // 可选
const muliEmptySite_3_L = require('./images/Seat_Couple/Seat_Available_Price 3_Left.png'); // 可选
const muliEmptySite_3_L_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 3_left.png'); // 可选
const muliEmptySite_3_R = require('./images/Seat_Couple/Seat_Available_Price 3__Right.png'); // 可选
const muliEmptySite_3_R_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 3_right.png'); // 可选
const muliEmptySite_4_L = require('./images/Seat_Couple/Seat_Available_Price 4_Left.png'); // 可选
const muliEmptySite_4_L_U = require('./images/Seat_Couple/u/Seat_Available_Price 4_Left.png'); // 可选
const muliEmptySite_4_R = require('./images/Seat_Couple/Seat_Available_Price 4__Right.png'); // 可选
const muliEmptySite_4_R_U = require('./images/Seat_Couple/u/Seat_Available_Price 4__Right.png'); // 可选
const muliEmptySite_5_L = require('./images/Seat_Couple/Seat_Available_Price 5_Left.png'); // 可选
const muliEmptySite_5_L_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 5_left.png'); // 可选
const muliEmptySite_5_R = require('./images/Seat_Couple/Seat_Available_Price 5__Right.png'); // 可选
const muliEmptySite_5_R_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 5_right.png'); // 可选
const muliEmptySite_6_L = require('./images/Seat_Couple/Seat_Available_Price 6_Left.png'); // 可选
const muliEmptySite_6_L_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 6_left.png'); // 可选
const muliEmptySite_6_R = require('./images/Seat_Couple/Seat_Available_Price 6__Right.png'); // 可选
const muliEmptySite_6_R_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 6_right.png'); // 可选
const muliEmptySite_7_L = require('./images/Seat_Couple/Seat_Available_Price 7_Left.png'); // 可选
const muliEmptySite_7_L_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 7_left.png'); // 可选
const muliEmptySite_7_R = require('./images/Seat_Couple/Seat_Available_Price 7__Right.png'); // 可选
const muliEmptySite_7_R_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 7_right.png'); // 可选
const muliEmptySite_8_L = require('./images/Seat_Couple/Seat_Available_Price 8_Left.png'); // 可选
const muliEmptySite_8_L_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 8_left.png'); // 可选
const muliEmptySite_8_R = require('./images/Seat_Couple/Seat_Available_Price 8__Right.png'); // 可选
const muliEmptySite_8_R_U = require('./images/Seat_Couple/u/Couple_unSelected_Price 8_right.png'); // 可选

// 单票价  单座
const emptyImg = new Image();
emptyImg.src = emptySite;
const singleSeled = new Image();
singleSeled.src = singleSite; //  已选中座位
const singleUnSeled = new Image();
singleUnSeled.src = singleEmptySite; // 可选座位
const singlefixSite = new Image();
singlefixSite.src = fixSingleSite;
const singleSaled = new Image(); // 已售座位
singleSaled.src = saledSite;

// 单票价 情侣座位 可选
const muUnseledLeft = new Image();
muUnseledLeft.src = muliUnseledLeft; //  可选
const muUnseledRight = new Image();
muUnseledRight.src = muliUnseledRight;
const muSeledLeft = new Image(); // 选中
muSeledLeft.src = muliSeledLeft;
const muSeledRight = new Image();
muSeledRight.src = muliSeledRight;
const muSaledLeft = new Image(); // 已售
muSaledLeft.src = muliSaledLeft;
const muSaledRight = new Image();
muSaledRight.src = muliSaledRight;

// 多票价 单座

const singleUnSeled_MulP_1 = new Image(); // 可选座位 高亮
singleUnSeled_MulP_1.src = singleEmptySite_1;
const singleUnSeled_MulP_1_U = new Image(); // 可选 暗色
singleUnSeled_MulP_1_U.src = singleEmptySite_1_U;

const singleUnSeled_MulP_2 = new Image(); // 可选座位 高亮
singleUnSeled_MulP_2.src = singleEmptySite_2;
const singleUnSeled_MulP_2_U = new Image(); // 可选 暗色
singleUnSeled_MulP_2_U.src = singleEmptySite_2_U;

const singleUnSeled_MulP_3 = new Image(); // 可选座位 高亮
singleUnSeled_MulP_3.src = singleEmptySite_3;
const singleUnSeled_MulP_3_U = new Image(); // 可选 暗色
singleUnSeled_MulP_3_U.src = singleEmptySite_3_U;

const singleUnSeled_MulP_4 = new Image(); // 可选座位 高亮
singleUnSeled_MulP_4.src = singleEmptySite_4;
const singleUnSeled_MulP_4_U = new Image(); // 可选 暗色
singleUnSeled_MulP_4_U.src = singleEmptySite_4_U;

const singleUnSeled_MulP_5 = new Image(); // 可选座位 高亮
singleUnSeled_MulP_5.src = singleEmptySite_5;
const singleUnSeled_MulP_5_U = new Image(); // 可选 暗色
singleUnSeled_MulP_5_U.src = singleEmptySite_5_U;

const singleUnSeled_MulP_6 = new Image(); // 可选座位 高亮
singleUnSeled_MulP_6.src = singleEmptySite_6;
const singleUnSeled_MulP_6_U = new Image(); // 可选 暗色
singleUnSeled_MulP_6_U.src = singleEmptySite_6_U;

const singleUnSeled_MulP_7 = new Image(); // 可选座位 高亮
singleUnSeled_MulP_7.src = singleEmptySite_7;
const singleUnSeled_MulP_7_U = new Image(); // 可选 暗色
singleUnSeled_MulP_7_U.src = singleEmptySite_7_U;

const singleUnSeled_MulP_8 = new Image(); // 可选座位 高亮
singleUnSeled_MulP_8.src = singleEmptySite_8;
const singleUnSeled_MulP_8_U = new Image(); // 可选 暗色
singleUnSeled_MulP_8_U.src = singleEmptySite_8_U;

// 多票价 情侣座
const muUnSeled_MulP_1_L = new Image(); // 可选座位 高亮
muUnSeled_MulP_1_L.src = muliEmptySite_1_L;
const muUnSeled_MulP_1_L_U = new Image(); // 可选 暗色
muUnSeled_MulP_1_L_U.src = muliEmptySite_1_L_U;
const muUnSeled_MulP_1_R = new Image(); // 可选座位 高亮
muUnSeled_MulP_1_R.src = muliEmptySite_1_R;
const muUnSeled_MulP_1_R_U = new Image(); // 可选 暗色
muUnSeled_MulP_1_R_U.src = muliEmptySite_1_R_U;

const muUnSeled_MulP_2_L = new Image(); // 可选座位 高亮
muUnSeled_MulP_2_L.src = muliEmptySite_2_L;
const muUnSeled_MulP_2_L_U = new Image(); // 可选 暗色
muUnSeled_MulP_2_L_U.src = muliEmptySite_2_L_U;
const muUnSeled_MulP_2_R = new Image(); // 可选座位 高亮
muUnSeled_MulP_2_R.src = muliEmptySite_2_R;
const muUnSeled_MulP_2_R_U = new Image(); // 可选 暗色
muUnSeled_MulP_2_R_U.src = muliEmptySite_2_R_U;

const muUnSeled_MulP_3_L = new Image(); // 可选座位 高亮
muUnSeled_MulP_3_L.src = muliEmptySite_3_L;
const muUnSeled_MulP_3_L_U = new Image(); // 可选 暗色
muUnSeled_MulP_3_L_U.src = muliEmptySite_3_L_U;
const muUnSeled_MulP_3_R = new Image(); // 可选座位 高亮
muUnSeled_MulP_3_R.src = muliEmptySite_3_R;
const muUnSeled_MulP_3_R_U = new Image(); // 可选 暗色
muUnSeled_MulP_3_R_U.src = muliEmptySite_3_R_U;

const muUnSeled_MulP_4_L = new Image(); // 可选座位 高亮
muUnSeled_MulP_4_L.src = muliEmptySite_4_L;
const muUnSeled_MulP_4_L_U = new Image(); // 可选 暗色
muUnSeled_MulP_4_L_U.src = muliEmptySite_4_L_U;
const muUnSeled_MulP_4_R = new Image(); // 可选座位 高亮
muUnSeled_MulP_4_R.src = muliEmptySite_4_R;
const muUnSeled_MulP_4_R_U = new Image(); // 可选 暗色
muUnSeled_MulP_4_R_U.src = muliEmptySite_4_R_U;

const muUnSeled_MulP_5_L = new Image(); // 可选座位 高亮
muUnSeled_MulP_5_L.src = muliEmptySite_5_L;
const muUnSeled_MulP_5_L_U = new Image(); // 可选 暗色
muUnSeled_MulP_5_L_U.src = muliEmptySite_5_L_U;
const muUnSeled_MulP_5_R = new Image(); // 可选座位 高亮
muUnSeled_MulP_5_R.src = muliEmptySite_5_R;
const muUnSeled_MulP_5_R_U = new Image(); // 可选 暗色
muUnSeled_MulP_5_R_U.src = muliEmptySite_5_R_U;

const muUnSeled_MulP_6_L = new Image(); // 可选座位 高亮
muUnSeled_MulP_6_L.src = muliEmptySite_6_L;
const muUnSeled_MulP_6_L_U = new Image(); // 可选 暗色
muUnSeled_MulP_6_L_U.src = muliEmptySite_6_L_U;
const muUnSeled_MulP_6_R = new Image(); // 可选座位 高亮
muUnSeled_MulP_6_R.src = muliEmptySite_6_R;
const muUnSeled_MulP_6_R_U = new Image(); // 可选 暗色
muUnSeled_MulP_6_R_U.src = muliEmptySite_6_R_U;

const muUnSeled_MulP_7_L = new Image(); // 可选座位 高亮
muUnSeled_MulP_7_L.src = muliEmptySite_7_L;
const muUnSeled_MulP_7_L_U = new Image(); // 可选 暗色
muUnSeled_MulP_7_L_U.src = muliEmptySite_7_L_U;
const muUnSeled_MulP_7_R = new Image(); // 可选座位 高亮
muUnSeled_MulP_7_R.src = muliEmptySite_7_R;
const muUnSeled_MulP_7_R_U = new Image(); // 可选 暗色
muUnSeled_MulP_7_R_U.src = muliEmptySite_7_R_U;

const muUnSeled_MulP_8_L = new Image(); // 可选座位 高亮
muUnSeled_MulP_8_L.src = muliEmptySite_8_L;
const muUnSeled_MulP_8_L_U = new Image(); // 可选 暗色
muUnSeled_MulP_8_L_U.src = muliEmptySite_8_L_U;
const muUnSeled_MulP_8_R = new Image(); // 可选座位 高亮
muUnSeled_MulP_8_R.src = muliEmptySite_8_R;
const muUnSeled_MulP_8_R_U = new Image(); // 可选 暗色
muUnSeled_MulP_8_R_U.src = muliEmptySite_8_R_U;

// 单座位
export const SINGLE = {
  EMPTY: emptyImg, //new Image(),     // 0   空 不展示，表示走廊
  // 单票价
  UNSELED: singleUnSeled, // 1  // 可选座位
  SELED: singleSeled, // 2  // 已选中座位
  FIX: singlefixSite, // 3
  SALED: singleSaled // 4  // 已售 座位
};
export const MULT = {
  // 单票价 情侣座
  UNSELED: [muUnseledLeft, muUnseledRight], // 5 可选
  SELED: [muSeledLeft, muSeledRight], // 6  已选
  SALED: [muSaledLeft, muSaledRight] // 7  已售
};

// 多票价，获取 座位图片 , info= '1-1' , normal 是正常图还是 带灰色图
// 单票价返回 src, 多票价返回arr数组.  这里扩容到18. 18以后不会选中
export const getImgFormSiteInfo = (state: number, activeIndex: number): any => {
  if ((state > 100 && state < 200) || (state > 500 && state < 600)) {
    const fi = Math.floor(state / 100);
    const idx = state % 100;
    // activeIndex 从 0 开始。 -1 表示没有选择。
    let normal = activeIndex === -1 || activeIndex + 1 === idx;
    let arr: any;
    if (fi === 5) {
      switch (idx) {
      case 1:
        normal
          ? (arr = [muUnSeled_MulP_1_L, muUnSeled_MulP_1_R])
          : (arr = [muUnSeled_MulP_1_L_U, muUnSeled_MulP_1_R_U]);
        break;
      case 2:
        normal
          ? (arr = [muUnSeled_MulP_2_L, muUnSeled_MulP_2_R])
          : (arr = [muUnSeled_MulP_2_L_U, muUnSeled_MulP_2_R_U]);
        break;
      case 3:
        normal
          ? (arr = [muUnSeled_MulP_3_L, muUnSeled_MulP_3_R])
          : (arr = [muUnSeled_MulP_3_L_U, muUnSeled_MulP_3_R_U]);
        break;
      case 4:
        normal
          ? (arr = [muUnSeled_MulP_4_L, muUnSeled_MulP_4_R])
          : (arr = [muUnSeled_MulP_4_L_U, muUnSeled_MulP_4_R_U]);
        break;
      case 5:
        normal
          ? (arr = [muUnSeled_MulP_5_L, muUnSeled_MulP_5_R])
          : (arr = [muUnSeled_MulP_5_L_U, muUnSeled_MulP_5_R_U]);
        break;
      case 6:
        normal
          ? (arr = [muUnSeled_MulP_6_L, muUnSeled_MulP_6_R])
          : (arr = [muUnSeled_MulP_6_L_U, muUnSeled_MulP_6_R_U]);
        break;
      case 7:
        normal
          ? (arr = [muUnSeled_MulP_7_L, muUnSeled_MulP_7_R])
          : (arr = [muUnSeled_MulP_7_L_U, muUnSeled_MulP_7_R_U]);
        break;
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
      case 14:
      case 15:
      case 16:
      case 17:
      case 18:
        normal
          ? (arr = [muUnSeled_MulP_8_L, muUnSeled_MulP_8_R])
          : (arr = [muUnSeled_MulP_8_L_U, muUnSeled_MulP_8_R_U]);
        break;
      default:
        arr = [muUnseledLeft, muUnseledRight];
      }
    } else if (fi === 1) {
      switch (idx) {
      case 1:
        normal ? (arr = singleUnSeled_MulP_1) : (arr = singleUnSeled_MulP_1_U);
        break;
      case 2:
        normal ? (arr = singleUnSeled_MulP_2) : (arr = singleUnSeled_MulP_2_U);
        break;
      case 3:
        normal ? (arr = singleUnSeled_MulP_3) : (arr = singleUnSeled_MulP_3_U);
        break;
      case 4:
        normal ? (arr = singleUnSeled_MulP_4) : (arr = singleUnSeled_MulP_4_U);
        break;
      case 5:
        normal ? (arr = singleUnSeled_MulP_5) : (arr = singleUnSeled_MulP_5_U);
        break;
      case 6:
        normal ? (arr = singleUnSeled_MulP_6) : (arr = singleUnSeled_MulP_6_U);
        break;
      case 7:
        normal ? (arr = singleUnSeled_MulP_7) : (arr = singleUnSeled_MulP_7_U);
        break;
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
      case 14:
      case 15:
      case 16:
      case 17:
      case 18:
        normal ? (arr = singleUnSeled_MulP_8) : (arr = singleUnSeled_MulP_8_U);
        break;

      default:
        arr = singleEmptySite;
      }
    }
    return arr;
  } else {
    return singleEmptySite;
  }
};
